import { GitPullRequest, ExternalLink } from "lucide-react";
import { GithubPullRequest } from "@shared/types/WorkOrderDto";
import { formatDate } from "./utils";

export function PullRequestCard({ pr }: { pr: GithubPullRequest }) {
  return (
    <a
      href={pr.link}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-start gap-3 p-3 rounded-lg border border-border/50 hover:bg-card/50 hover:border-primary/30 transition-all"
    >
      <div className="w-8 h-8 rounded-lg bg-purple-500/10 flex items-center justify-center shrink-0">
        <GitPullRequest className="h-4 w-4 text-purple-500" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{pr.title}</p>
        <p className="text-xs text-muted-foreground truncate mt-0.5">
          {pr.description}
        </p>
        <div className="flex items-center gap-2 mt-1 text-xs text-muted-foreground">
          <span>
            {pr.originBranch} → {pr.targetBranch}
          </span>
          <span>•</span>
          <span>{formatDate(pr.createdAt)}</span>
        </div>
      </div>
      <ExternalLink className="h-4 w-4 text-muted-foreground shrink-0" />
    </a>
  );
}
